/**
 * Created by fers on 25.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, IntlShape} from 'react-intl';
import urlMapping from '../app/URLMapping';
import {Link} from 'react-router';
import './channel-defs.scss';
import {safeJSONparse} from "../../common/util/safeJSONparse";

interface ValidationDefinitionResultProps {
    validationResult?: object;
}

export default class ValidationDefinitionResult extends React.Component<ValidationDefinitionResultProps> {
    static propTypes = {
        validationResult: PropTypes.object,
    };

    renderMessages() {
        let validationResult = this.props.validationResult;
        let currentUrl = window.location.pathname;

        if (validationResult && validationResult.messages && validationResult.messages.length > 0) {
            return (<ul>
                    {validationResult.messages.map((str, idx) => {
                        let ids = safeJSONparse(str.id);

                        let url = null;
                        if (str.id && str.type) {
                            url = urlMapping.getUrl(str.type, str.action ? str.action : 'view', ids);
                        }

                        if (currentUrl === url) {
                            url = null;
                        }

                        return (<li key={idx}>
                                {url ?
                                    <Link to={url}>{str.msg}</Link>
                                    :
                                    str.msg
                                }
                            </li>
                        );
                    })}
                </ul>
            );
        } else {
            return null;
        }

    }

    render() {
        let validationResult = this.props.validationResult;
        if (validationResult) {
            if (validationResult.success) {
                return (
                    <div className="bs-callout bs-callout-success">
                        {validationResult.messages && validationResult.messages.length === 0 ?
                            <p><FormattedMessage defaultMessage="Validation result:" id="validationDefinition.validationResult"/>
                                {" "}
                                <strong style={{color: 'green'}}>
                                    <FormattedMessage defaultMessage="OK" id="channelDef.validationResultOk"/>
                                </strong>
                            </p>
                        : null}
                        {this.renderMessages()}
                    </div>
                );
            } else {
                return (
                    <div className="bs-callout bs-callout-danger validationResult-error">
                        <p><FormattedMessage defaultMessage="Validation error:" id="validationDefinition.validationError"/></p>
                        {this.renderMessages()}
                    </div>
                );
            }
        }

        return null;
    }
}
